import { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import { ModalBase } from '@components/Modal';
import Button from '@components/Button';
import { createProxyObject } from '@helpers/createProxyObject';
import { useTranslation } from '@hooks';
import { LOCALE } from '@constants/locale';

const Modal = styled(ModalBase)({
    '& .modal-base-paper': {
        outline: 'none',
        width: 830,
        maxWidth: 'calc(100% - 32px)',
        height: 680,
        '@media (max-width: 900px)': {
            height: 'var(--100vh)',
            maxWidth: 'none',
            width: '100%',
            borderRadius: 0,
        },
    },
});

const ContactSalesButton = ({ className, variant = 'contained', ...props }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const account = useSelector(state => state.account?.account);
    const user = useSelector(state => state.auth.user);
    const locale = account?.locale;
    const { t } = useTranslation();

    const SaleManagerMap = createProxyObject({
        [LOCALE.SPAIN]: 'joao-pedro-brasil/product-sales-spain',
        [LOCALE.PORTUGAL]: 'joao-pedro-brasil/product-sales-brazil',
        [LOCALE.BRAZIL]: 'joao-pedro-brasil/product-sales-brazil',
        default: 'sergio-shanin/product-sales-global',
    });

    const emailQuerystring = user?.email ? `&email=${user?.email}` : '';
    const firstNameQuerystring = user?.firstName ? `&firstname=${user?.firstName}` : '';
    const lastNameQuerystring = user?.lastName ? `&lastname=${user?.lastName}` : '';
    const queryParams = `?embed=true${emailQuerystring}${firstNameQuerystring}${lastNameQuerystring}`;
    const iframeSrc = `https://meetings.hubspot.com/${SaleManagerMap[locale]}${queryParams}`;

    const onOpenModal = () => setIsModalOpen(true);

    return (
        <>
            <Button variant={variant} className={className} onClick={onOpenModal} {...props}>
                {t('buttons.talkToSales')}
            </Button>
            {isModalOpen ? (
                <Modal
                    isOpen={isModalOpen}
                    aboveModal
                    handleClose={() => setIsModalOpen(false)}
                    title={t('buttons.talkToSales')}
                >
                    <div style={{ height: '100%', width: '100%', position: 'relative' }}>
                        <iframe
                            title="hubspot"
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                bottom: 0,
                                right: 0,
                                width: '100%',
                                height: '100%',
                                border: 'none',
                            }}
                            src={iframeSrc}
                        />
                    </div>
                </Modal>
            ) : null}
        </>
    );
};

export default ContactSalesButton;
